import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ClipboardList, BadgeDollarSign, CalendarCheck, ArrowRight } from "lucide-react";

const STEPS = [
  { id: "answer", icon: ClipboardList, title: "Answer a few questions", desc: "Tell us what you need done and a little about your property. Takes under a minute." },
  { id: "estimate", icon: BadgeDollarSign, title: "Get your estimate instantly", desc: "We work out an honest estimate from your answers — right there on the screen." },
  { id: "book", icon: CalendarCheck, title: "Happy? Book it in", desc: "Pick a time that suits you and we'll come and get it sorted. Easy." },
];

const reveal = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
};
const WHITE_BG = { backgroundColor: "#fff" };

export const Process = () => {
  const navigate = useNavigate();
  return (
    <section id="process" className="py-20 lg:py-28 bg-cream scroll-mt-20">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-xs tracking-[0.2em] uppercase text-lawn font-bold mb-3">How it works</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-ink">
            A quote in three simple steps
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.id}
              {...reveal}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="relative bg-surface border border-line rounded-2xl p-8 text-center"
              style={WHITE_BG}
            >
              <span className="absolute top-6 right-7 font-heading text-5xl font-extrabold text-sand">
                {i + 1}
              </span>
              <div className="w-16 h-16 rounded-2xl bg-forest text-cream flex items-center justify-center mx-auto mb-6">
                <s.icon className="w-8 h-8" strokeWidth={1.8} />
              </div>
              <h3 className="font-heading text-xl font-bold text-ink">{s.title}</h3>
              <p className="mt-3 text-ink-soft leading-relaxed">{s.desc}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <button
            data-testid="process-get-quote"
            onClick={() => navigate("/quote")}
            className="group inline-flex items-center gap-2 rounded-full bg-lawn text-forest-dark px-8 py-4 text-base font-extrabold hover:bg-lawn-light transition-colors"
          >
            Start My Free Quote
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </section>
  );
};
